import styled, { css } from 'styled-components';
import { motion } from 'motion/react'
import { setLayoutWidth } from 'styles/sharedStyles';

export const MobileMenuIcon = styled.button`
  display: none;
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: block;
  }
`;

export const GlobalHeaderContainer = styled.div`
  background-image: url('/images/headerBackground.png');
  background-size: 250px;
  border-bottom: 3px solid rgba(190, 147, 60, 1);
`;

export const GlobalHeaderWrapper = styled.div`
  ${setLayoutWidth};
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DoctorMenuLink = styled.div`
  display: flex;
  align-items: center;
`;

export const DoctorName = styled.div`
  color: ${({ theme }) => theme.palette.white};
  font-weight: 400;
  margin-right: 10px;

  ${({ theme }) => theme.breakpoints.down('sm')} {
    display: none;
  }
`;

export const DesktopNavigationItemListContainer = styled.div`
  background: rgba(52, 58, 63, 1);
  ${({ theme }) => theme.breakpoints.down('lg')} {
    display: none;
  }
`;

export const MobileNavigationItemListContainer = styled(motion.div)`
  background: rgba(52, 58, 63, 1);
  ${({ theme }) => theme.breakpoints.down('lg')} {
    position: absolute;
    width: 100%;
    z-index: 10;
  }
`;

export const DesktopNavigationItemList = styled.div`
  ${setLayoutWidth};
  margin: 0 auto;
  display: flex;
  font-size: 1.1rem;
  color: rgba(157, 157, 157, 1);
  font-weight: 400;
  gap: 32px;
  flex-direction: row;
`;

export const MobileNavigationItemList = styled.div`
  ${setLayoutWidth};
  margin: 0 auto;
  display: flex;
  font-size: 1.1rem;
  color: rgba(157, 157, 157, 1);
  font-weight: 400;
  display: flex;
  gap: 2%;

  flex-direction: column;
`;

const getGoldenBorder = css`
  border-bottom: 4px solid rgba(190, 147, 60, 1);
  color: #fff;
  font-weight: 500;
`;

export const AppName = styled.a<{ isActive: boolean }>`
  text-decoration: none;
  color: inherit;
  border-bottom: 4px solid transparent;
  padding: 12px 4px;
  transition: color 0.2s ease, border-color 0.2s ease;

  &:hover {
    ${getGoldenBorder}
  }

  cursor: pointer;
  ${props => props.isActive && getGoldenBorder}
`;

export const SubNavigationList = styled.ul`
  background: #1a1a1a;

  list-style-type: none;
  padding-left: 0px;

  border-radius: ${({ theme }) => theme.borderRadius};

  color: grey !important;
  font-weight: 300;
`;

export const SubNavigationListItem = styled.li`
  padding: 1%;
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 1.5%;
  }
  ${({ theme }) => theme.breakpoints.down('md')} {
    padding: 2%;
  }
  cursor: pointer;

  border-bottom: 4px solid #1a1a1a;

  &:hover {
    color: #fff;
    font-weight: 500;
    border-bottom: 4px solid rgba(190, 147, 60, 1);
  }
`;

export const LinkText = styled.a`
  text-decoration: none;
  color: inherit;
`;

export const GlobalAppName = styled.div<{ isActive: boolean }>`
  border-bottom: 4px solid rgba(52, 58, 63, 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
  padding: 10px 0px;
  &:hover {
    border-bottom: 4px solid rgba(190, 147, 60, 1);
  }
  ${props => props.isActive && getGoldenBorder}
`;

export const DoctorMenu = styled.div`
  position: relative;
  cursor: pointer;
`;

const getMenuPostion = (
  left?: string,
  right?: string,
  top?: string,
  bottom?: string
) => {
  return css`
    left: ${left ? left : 'auto'};
    right: ${right ? right : 'auto'};
    top: ${top ? top : 'auto'};
    bottom: ${bottom ? bottom : 'auto'};
  `;
};

export const Menu = styled.div<{
  left?: string;
  right?: string;
  top?: string;
  bottom?: string;
}>`
  position: absolute;
  width: 220px;
  background: white;
  z-index: 5;
  box-shadow: ${({ theme }) => theme.shadows.sm};
  border-radius: ${({ theme }) => theme.borderRadius};
  padding: 5px 0px;
  right: 0px;
  transition: opacity 151ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
    transform 167ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  ${({ left, right, top, bottom }) => getMenuPostion(left, right, top, bottom)}
`;
export const MenuItem = styled.div`
  padding: 6px 16px;
  width: auto;
  &:hover {
    background: ${({ theme }) => theme.palette.grey13};
  }
`;
